import React, { useState, useEffect } from 'react';
import '../catalogue/styles.css';
import VisibleIcon from '@rsuite/icons/Visible';
import { Link } from 'react-router-dom';
import {
  Input,
  InputGroup,
  Button,
  Form,
  CheckPicker,
  Checkbox,
  Stack,
  Breadcrumb,
  Divider,
  Panel,
  Col,
  FlexboxGrid,
  Container,
  Notification,
  Modal,
  Loader,
  ButtonToolbar,
  IconButton
} from 'rsuite';
import SearchIcon from '@rsuite/icons/Search';
import DrawerView from './DrawerView';

interface PaginationData {
  page: number;
  pageSize: number;
  pageCount: number;
  total: number;
}

interface MetaData {
  pagination: PaginationData;
}

const Selection = () => {

  // Scanning Modal function Start
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  // Scanning Modal function End

  const [isCartOpen, setIsCartOpen] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const handleCheckAll = (value, checked) => {
    if (checked) {
      setSelectedItems(data123.map((item) => item.id)); // Replace "id" with your unique identifier property
    } else {
      setSelectedItems([]);
    }
  };
  const handleCheckboxChange = (value, checked) => {

    if (checked) {
      setSelectedItems((prevSelectedItems) => [...prevSelectedItems, value]);
    } else {
      setSelectedItems((prevSelectedItems) => prevSelectedItems.filter((item) => item !== value));
    }
  };

  // const handleCartOpen = () => {
  //   setIsCartOpen(true);
  // };

  const handleCartClose = () => {
    setIsCartOpen(false);
  };

  // const navigate = useNavigate();
  

  // const handleCartOpen = () => {
    

  //   // Convert the selected items array to a comma-separated string
  //   const selectedItemsString = selectedItems.join(',');

  //   // Navigate to the editDetails page with the selected items as a query parameter
  //   // navigate(`/editDetails?selectedItems=${selectedItemsString}`);
  //   const url = `/editDetails?selectedItems=${selectedItemsString}`;
  //   window.location.href = url;
  // };



  const [showDrawer, setShowDrawer] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState('');
  const subcategory = ['Fabric (3)', 'Finishing (4)', 'Metal (8)', 'Packing (5)', 'Verse (6)', 'Wooden (2)', 'Packing (5)'].map(
    item => ({ label: item, value: item })
  );
  const AddedOn = ['Today', 'Yesterday', 'This week', 'Last week', 'This month', 'Last month', 'Last 3 month', 'Last 6 month'].map(
    item => ({ label: item, value: item })
  );

  // Api Start
  const [data123, setData123] = useState([]);
  const [meta123, setMeta123] = useState<MetaData>();
  useEffect(() => {
    const fetchData = async () => {
      const response = await fetch('http://192.168.1.83:1337/api/products?populate=*');
      const json = await response.json();
      setData123(json.data);
      setMeta123(json.meta)
    };
    fetchData();


  }, []);

  const ip = 'http://192.168.1.83:1337';
  // Api End



  return (
    <>
      <Container className='main'>
        <Stack className="table-toolbar" justifyContent="space-between">
          <Stack direction='column' alignItems='flex-start'>
            <Stack direction='column' alignItems='flex-start' >
              <h3 className="title">Catalogues</h3>
              <Breadcrumb>
                <Breadcrumb.Item href="/dashboard">Home</Breadcrumb.Item>
                <Breadcrumb.Item href="/catalogue">Create Catalogue</Breadcrumb.Item>
                <Breadcrumb.Item active>Select Product</Breadcrumb.Item>
              </Breadcrumb>
            </Stack>
            <Form.ControlLabel className='title'>Summer Collection 2023 For XYZ</Form.ControlLabel>
            <Stack spacing={5}>
              <CheckPicker data={subcategory} size="xs" appearance="default" placeholder="Category" style={{ width: 116 }} />
              <CheckPicker data={subcategory} size="xs" appearance="default" placeholder="Sub Category" style={{ width: 116 }} />
              <CheckPicker data={AddedOn} size="xs" appearance="default" placeholder="Added On" style={{ width: 116 }} />
              <CheckPicker data={AddedOn} size="xs" appearance="default" placeholder="Updated On" style={{ width: 116 }} />
              <Button appearance="default" active onClick={() => setShowDrawer(true)}>
                More Filter
              </Button>
            </Stack>
          </Stack>

          <Stack direction='column' alignItems='flex-end' spacing={53}>
            <Stack direction='row' spacing={5}>
              <InputGroup inside >
                <Input placeholder="Search" value={searchKeyword} onChange={setSearchKeyword} />
                <InputGroup.Addon>
                  <SearchIcon />
                </InputGroup.Addon>
              </InputGroup>
              <Button appearance="default" active>
                <SearchIcon /> Smart Search
              </Button>
            </Stack>
            <Stack spacing={10}>
              <Checkbox
                indeterminate={selectedItems.length > 0 && selectedItems.length < data123.length}
                checked={selectedItems.length === data123.length}
                onChange={handleCheckAll}
              >
                Select all
              </Checkbox>
              <Button appearance="default" active>
                Product ID Desc
              </Button>
            </Stack>
          </Stack>

        </Stack>
        <Divider className='divide' />
        <div className="row">
          <Panel>
            {meta123 && (
              <b style={{ marginLeft: '6px' }}>Total Products: {meta123.pagination.total}</b>
            )}
            {/* <CheckboxGroup inline name="checkboxList" value={value} onChange={handleChange1} > */}
            <FlexboxGrid justify="space-between" style={{ textAlign: 'center' }}>
              {data123.map((item) => (
                <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                  <Panel className='box' bordered bodyFill style={{ display: 'inline-block', width: '100%' }}>
                    <Stack><Checkbox
                      value={item.id} // Replace "id" with your unique identifier property
                      checked={selectedItems.includes(item.id)}
                      onChange={(value, checked) => handleCheckboxChange(value, checked)}
                    /></Stack>
                    <img src={`${ip}${item.attributes.CoverImage.data.attributes.url}`} className='imgp' />
                    <Panel>
                      <b>Product Name : {item.attributes.ProductName} </b>
                      <p>
                        Alias Code : {item.attributes.ProductId}
                      </p>
                    </Panel>
                  </Panel>
                </FlexboxGrid.Item>
              ))}
            </FlexboxGrid>

            {selectedItems.length > 0 && (
              <Notification type="success"
                onClose={handleCartClose}
                style={{
                  position: 'fixed',
                  top: '80%', right: 20, 
                  transform: 'translateY(-50%)', 
                  zIndex: 9999, 
                  background: 'rgb(129 129 129)', 
                  color: 'white', 
                  width: '20%',
                }}>

                <b style={{ color: 'white' }}>Selected Products : {selectedItems.length}</b>

                <Divider />
                <Link to={{ pathname: '/editDetails', search: `?selectedItems=${selectedItems.join(',')}` }} >   
                 <IconButton icon={<VisibleIcon />}><b>View</b></IconButton>
                </Link>

              </Notification>

            )}

            {/* {isCartOpen && (
        <div className="side-cart-overlay">
          <div className="side-cart-content">
            <div className="side-cart-header">
              <h3>Selected Items</h3>
              <Button onClick={handleCartClose} appearance="subtle">
                Close
              </Button>
            </div>
            <div className="side-cart-body">
              <div>Number of selected items: {selectedItems.length}</div>
            </div>
          </div>
        </div>
      )} */}
            {/* </CheckboxGroup> */}
          </Panel>
        </div>
        {/* scanning modal start */}
        <Modal open={open} onClose={handleClose}>
          <Modal.Body>
            <Panel style={{ height: "40vh" }} bordered>
              <Stack justifyContent="center">
                <h6> Scannig data for x products</h6>
              </Stack>
              <Loader size="lg" center content="loading..." />
              <Stack justifyContent="center" >
                <p>
                  Creating the table might take a few minutes. please be patients</p>
              </Stack>
              <Stack justifyContent="center" >
                <p> and do not close this window untill it's complete</p>
              </Stack>

            </Panel>
          </Modal.Body>

        </Modal>


        {/* scanning modal End */}
        <Stack className="copyright" justifyContent="space-between" style={{ 'position': 'fixed', 'bottom': '0', 'width': '-webkit-fill-available', 'textAlign': 'center', 'backgroundColor': 'white' }}>
          <div className="container">
            <p>© All Right Reserved. Product by </p>
          </div>
          <div><p> <a href="http://hitouchtechnologies.com/" target="_blank">Hitouch Technologies (P) Ltd.</a></p></div>
        </Stack>
        <DrawerView open={showDrawer} onClose={() => setShowDrawer(false)} />
      </Container>
    </>
  );
};

export default Selection;